import { useReducedMotion } from 'framer-motion'
import { Button } from '@/ui/components'
import { MEDIA_CONFIG } from '@/shared/utils/media'
import { cn } from '@/shared/utils'

export function Landing3DHero() {
  const reducedMotion = useReducedMotion() ?? false

  return (
    <section className="relative min-h-[85svh] w-full overflow-hidden bg-earth-900">
      {/* Video background — poster is the LCP element, video plays on top */}
      {reducedMotion ? (
        <img
          src={MEDIA_CONFIG.hero.image.src}
          alt="Aerial view of overlanding rigs on a backcountry route"
          className="absolute inset-0 h-full w-full object-cover"
          // @ts-expect-error fetchpriority is valid HTML but missing from React 18's img typings
          fetchpriority="high"
        />
      ) : (
        <video
          className="absolute inset-0 h-full w-full object-cover"
          src={MEDIA_CONFIG.hero.video.src}
          poster={MEDIA_CONFIG.hero.video.poster}
          autoPlay
          muted
          loop
          playsInline
        />
      )}

      {/* Scrim */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/60 via-black/25 to-black/70" />

      {/* Copy overlay */}
      <div className="relative z-10 flex min-h-[85svh] flex-col items-center justify-center px-6 py-20 text-center">
        <span className="rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-white/90 backdrop-blur-sm">
          Now in Public Beta
        </span>

        <h1 className="mt-8 max-w-4xl text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl lg:text-7xl">
          Plan the route. Bring the crew. Keep your spots.
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/90 sm:text-lg md:text-xl">
          SitRepp is the trip planner built for overlanding crews. Share a trip without
          giving away your spot: hide GPS and route detail on open links until you've
          vetted someone, while routes, meals, gear, and weather stay in one workspace.
        </p>

        <div className="mt-10 flex w-full max-w-md flex-col items-center justify-center gap-3 sm:flex-row">
          <Button size="lg" className="w-full sm:w-auto" asChild>
            <a href="/signup">Start planning free</a>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="w-full border-white/40 bg-white/10 text-white backdrop-blur-sm hover:bg-white/20 hover:text-white sm:w-auto"
            asChild
          >
            <a href="#collaboration">See how sharing works</a>
          </Button>
        </div>

        {/* Scroll cue */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70" aria-hidden>
          <svg
            className={cn('h-6 w-6', !reducedMotion && 'animate-bounce')}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 5v14" />
            <path d="m19 12-7 7-7-7" />
          </svg>
        </div>
      </div>
    </section>
  )
}
